// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--16n9_";
export var subContainer = "Footer-module--subContainer--1zsrI";
export var logoAndSocialsContainer = "Footer-module--logoAndSocialsContainer--rt56w";
export var menuContainer = "Footer-module--menuContainer--1dKeG";
export var item = "Footer-module--item--1vckW";
export var accordion = "Footer-module--accordion--3L0-7";
export var linksContainer = "Footer-module--linksContainer--1IVqp";